<template>
  <div id="app" v-if="authToken">
    <keep-alive :include="include">
      <!-- 需要缓存的视图组件 -->
      <router-view v-if="$route.meta.keepAlive"> </router-view>
    </keep-alive>

    <router-view v-if="!$route.meta.keepAlive"> </router-view>
  </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
  name: 'App',
  data() {
    return {
      include: [],
      version: '',
      orgBackground: '',
      off: null // 监听事件
    };
  },
  computed: {
    ...mapState({
      authToken: state => state.authToken,
      keepAliveInclude: state => state.keepAliveInclude
    })
  },
  beforeDestroy() {
    document.removeEventListener('UniAppJSBridgeReady', this.off);
    this.$store.commit('updateKeepAliveInclude', []);
  },
  watch: {
    $route(to, from) {
      // 如果 要 to(进入) 的页面是需要 keepAlive 缓存的，把 name push 进 include数组
      if (to.meta.keepAlive) {
        this.include.indexOf(to.name) === -1 && this.include.push(to.name);
      }
      // 如果 要 form(离开) 的页面是 keepAlive缓存的，
      // 再根据 deepth 来判断是前进还是后退
      if (from.meta.keepAlive && to.meta.deepth < from.meta.deepth) {
        var index = this.include.indexOf(from.name);
        index !== -1 && this.include.splice(index, 1);
      }
      this.$store.commit('updateKeepAliveInclude', this.include);
      this.setTitle(to.meta.title);
    }
  },
  mounted() {
    var that = this;
    window.Toast = function(e) {
      that.$toast(e);
    };
    window.setToken = function(token) {
      that.$store.commit('updateAuthToken', token);
    };
    this.off = function() {
      // eslint-disable-next-line
      uni.webView.getEnv(function(res) {
        // 主动初始化token
        // eslint-disable-next-line
        uni.webView.postMessage({
          data: {
            action: 'getToken',
            data: {
              success: 'setToken',
              error: 'Toast'
            }
          }
        });
        window.goBack = function () {
          console.log(that.$route);
          if (that.$route.name === '404' || that.$route.name === 'ai' || that.$route.name === 'ywq') {
            // eslint-disable-next-line
            uni.webView.postMessage({
              data: {
                action: 'Close'
              }
            });
          } else {
            that.$router.go(-1);
          }
        };
        // that.$message.info('当前环境：' + JSON.stringify(res))
      });
    };
    document.addEventListener('UniAppJSBridgeReady', this.off);
  },
  methods: {
    setTitle(title) {
      if (window.location.href.indexOf('localhost') > -1) {
        return;
      }
      window.document.title = title;
    }
  }
};
</script>

<style lang="less">
@import '../node_modules/vant/lib/index.css';
// @import '//at.alicdn.com/t/font_3021794_hhs50y8q39w.css'; // 特殊情况下字体丢失直接本地打包进去
@import './assets/css/style.less';
</style>
